import React from 'react';
import Head from 'next/head';

import ContactForm from '@/components/ContactForm/ContactForm';
import Container from '@/components/Container/Container';
import Header from '@/components/Header/Header';
import styles from '@/styles/Home.module.sass';

export default function ContactPage() {
  return (
    <div className={styles.container}>
      <Head>
        <title>contact | cake-mag.com</title>
        <meta
          key="description"
          name="description"
          content="Get in touch with us"
        />
        <meta
          key="ogDescription"
          property="og:description"
          content="Get in touch with us"
        />
      </Head>
      <Header />
      <Container>
        <section className="section">
          <h1>Say hello</h1>
          <ContactForm />
        </section>
      </Container>
    </div>
  );
}
